import { render } from "./ErrorOccured.vue?vue&type=template&id=9ae9b76c&scoped=true"
import script from "./ErrorOccured.vue?vue&type=script&lang=js"
export * from "./ErrorOccured.vue?vue&type=script&lang=js"

import "./ErrorOccured.vue?vue&type=style&index=0&id=9ae9b76c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae9b76c"]])

export default __exports__